import $ from 'jquery';

export default function () {
    $('#submit-form-preview-btn').on('click', function () {
        $('#Preview').val(true);
    });

    $('#submit-form-save-btn').on('click', function () {
        $('#Preview').val(false);
    });
};


// WEBPACK FOOTER //
// ./App/components/modules/coordinatesImport.js